import React from 'react';

import { Typography, DialogContent, IconButton } from '@mui/material';

import Box from '@mui/material/Box';

import { useTranslation } from 'next-i18next';

import Dialog from 'src/components/ui/Dialog';
import Icon from 'src/components/ui/Icon';
import Image from 'src/components/ui/Image';

import { colours } from 'src/constants/colours';
import { sanitizeHTMLContent } from 'src/utils/sanitizeHtml';
import useLoginModal from 'src/hooks/useLoginModal';
import { routePathInterests, routePathWelcomeAfterQuickSignUpPro } from 'src/constants/router';
import { styledComponent } from 'src/utils/styled';

const StyledDialog = styledComponent(Dialog)`
    .MuiDialogContent-root {
        padding: 2rem 1.875rem;
    }
`;

const StyledImage = styledComponent(Image)`
    background-color: transparent !important;
`;

const StyledTitle = styledComponent(Typography)`
    span {
        color: ${colours.secondary.main};
    }
`;

StyledDialog.defaultProps = {
    maxWidth: 'xs',
    fullWidth: true,
};

interface Props {
    open: boolean;
    onClose: () => void;
    isSignup?: boolean;
    isQuickSignup?: boolean;
}

const InvitationRequestSuccessModal: React.FC<Props> = ({ open, onClose, isSignup, isQuickSignup }) => {
    const { onEndFlow } = useLoginModal();
    const { t } = useTranslation(['company']);

    const handleClose = () => {
        onClose();
        if (isSignup) {
            onEndFlow(!isQuickSignup ? routePathInterests : routePathWelcomeAfterQuickSignUpPro);
        }
    };
    return (
        <StyledDialog open={open} onClose={handleClose}>
            <DialogContent>
                <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                    <div />
                    <StyledImage
                        src={`${process.env.NEXT_PUBLIC_SITE_URL}/assets/images/woopy-festive.png`}
                        alt="woopy-festive"
                        height={88}
                        width={110}
                    />
                    <IconButton aria-label="close" onClick={handleClose}>
                        <Icon name="Close" />
                    </IconButton>
                </Box>
                <Box display="flex" flexDirection="row" justifyContent="center" padding="1rem 0">
                    <StyledTitle
                        variant="h2"
                        align="center"
                        dangerouslySetInnerHTML={{
                            __html: sanitizeHTMLContent(t('company:invitationRequestSuccessModalTitle')),
                        }}
                    />
                </Box>
                <Box display="flex" flexDirection="row" justifyContent="center" padding="1rem 0">
                    <Typography variant="h4" align="center" style={{ fontWeight: 400 }}>
                        {t('company:invitationRequestSuccessModalContent')}
                    </Typography>
                </Box>
            </DialogContent>
        </StyledDialog>
    );
};

export default InvitationRequestSuccessModal;
